<template>
    <div class="sliderfilter-menu">
    <!-- <SaveFilter /> -->
    <div class="sliderfilter-card" v-for="(filterCard,index1) in selectedFilters" :key="index1">
      <div v-for="(filter,index2) in filterCard" :key="index2">
        <div class="sliderfilter-cardlist" v-if="checkPermission(filter)">
          <FilterCategory
            v-if="filter.type === 'List'"
            :category="filter.tlabel? $t(filter.tlabel) : $t(filter.category)"
            :list="filter.list"
            :search="filter.search"
            :selected="filter.selected"
            @updateOption="updateOption(index1, index2, $event, filter)"/>
          <template  v-if="filter.type === 'GroupList'">
            <div class="cardlist">
            <div class="cardlist-title">
              <label>{{filter.tlabel? $t(filter.tlabel) : filter.category}}</label>
            </div>
            <div class="cardlist-dropdown">
            <FilterGroupCategory
              :category="filter.tlabel? $t(filter.tlabel) : filter.category"
              :groupList="filter.list"
              :selected="filter.selected"
              :searchEnable="filter.searchEnable"
              v-on:updateOption = "updateOption(index1, index2, $event)"/>
            </div>
            </div>
          </template>
          <FilterMultipleDropdown
            v-else-if="filter.type === 'MultiSelectList'"
            :category="filter.tlabel? $t(filter.tlabel) : filter.category"
            :options="filter.list"
            :selected="filter.selected"
            :clearSelected="filter.clearSelected"
            :placeholder="filter.placeholder"
            :maxSelectionAllowed="filter.maxSelectionAllowed"
            :selectAllOption="filter.selectAllOption"
            :allowEmpty="filter.allowEmpty"
            :defaultSelectAll="filter.defaultSelectAll"
            :preSelectFirst="filter.preSelectFirst"
            :disableGates="( filter.queryParamString === 'gate_ids' ) && selectedFilters[0][0].selected.length>1"
            :disableDeliver="disableDeliver"
            @updateOption="updateOption(index1, index2, $event, filter)"
            @clearAllGA="$emit('clearAllGA',index1,index2)"/>
            <MultiSelectGroup
            v-else-if="filter.type === 'MultiSelectGroup'"
            ref="multiSelectGroupRef"
            :category="filter.tlabel? $t(filter.tlabel) : filter.category"
            :groups="filter.list"
            :selected="filter.selected"
            :idLabel="filter.idLabel"
            :maxSelectionAllowed="filter.maxSelectionAllowed"
            @updateOption="updateOption(index1, index2, $event, filter)"
            />
            <div class="cardlist" v-else-if="filter.type === 'Date'">
              <div class="cardlist-title">
                <label>{{filter.tlabel? $t(filter.tlabel) : (filter.label || filter.category)}}</label>
              </div>
              <div class="sliderfilter-cardlist-dropdown">
                <div class="datepickerrange calenderstyle">
                  <div class="datepicker-trigger">
                    <div :id="filter.category">{{formattedDate(filter.startDate, filter.endDate) || $t('INDENT_START_END_DATE')}}</div>
                    <AirbnbStyleDatepicker
                      :trigger-element-id="filter.category"
                      :mode="'range'"
                      :date-one="filter.startDate"
                      :date-two="filter.endDate"
                      :endDate="filter.maxDate || null"
                      @date-one-selected="val => { updateDate(val,'startDate', index1, index2 )}"
                      @date-two-selected="val => { updateDate(val,'endDate', index1, index2 )}"
                    />
                    </div>
                    <div class="datepickerrange-cancel">
                      <svgicon v-if="filter.optional && formattedDate(filter.startDate,filter.endDate)" name="cancelblack" class="icon-clear" @click="$emit('clearDate',index1,index2)" width="9" height="9" :original="true" />
                      <svgicon v-else name="fill_arrow" width="9" height="9" :original="true" />
                    </div>
                </div>
              </div>
            </div>

          <div class="cardlist" v-else-if="filter.type === 'DatePicker'" v-click-outside="closePicker">
            <div class="cardlist-title">
              <label>{{filter.tlabel? $t(filter.tlabel) : (filter.label || filter.category)}}</label>
            </div>
            <div class="date-picker">
              <div id="trigger-date-picker"></div>
              <div class="date-picker-value plain" @click="isDatePickerClicked=!isDatePickerClicked">
                <span>{{formattedDate(filter.startDate, filter.endDate) || $t('INDENT_START_END_DATE')}}</span>
                <i class="date-picker-prefix">
                  <svgicon
                      v-if="filter.optional && formattedDate(filter.startDate,filter.endDate)"
                      name="cancelblack"
                      class="icon-clear"
                      @click="$emit('clearDate',index1,index2, filter.type);isDatePickerClicked=!isDatePickerClicked"
                      width="9"
                      height="9"
                      :original="true" />
                    <svgicon
                      v-else
                      name="fill_arrow"
                      width="9"
                      height="9"
                      :original="true" />
                </i>
              </div>
              <div class="date-picker-panel" v-if="isDatePickerClicked">
                <div class="date-picker-header">
                  <Radio v-for="radioButton in filter.radioOptions"
                    :key="radioButton.paramKey"
                    class="radio-boxed" border v-model="selectedDateFilter"
                    @change="changeRadio(index1, index2)"
                    :label="radioButton.paramKey">
                    {{radioButton.displayLabel}}
                  </Radio>
                </div>
                <div class="date-picker-body"  >
                  <div v-if="selectedDateFilter == $t('INDENT_VEHICLE').toLowerCase() ">
                    <span class=" text-red pl-20" >{{$t('INDENT_DELIVERED_INDENTS_EXCLUDED')}}</span>
                  </div>
                  <AirbnbStyleDatepicker :mode="'range'" 
                    trigger-element-id="trigger-date-picker"
                    :date-one="filter.startDate"
                    :date-two="filter.endDate"
                    :endDate="maxDate || null"
                    :minDate="minDate || null"
                    inline
                    @date-one-selected="val => {getDateRange(selectedDateFilter,val, index1, index2); updateDate(val,'startDate', index1, index2)}"
                    @date-two-selected="val => {updateDate(val,'endDate', index1, index2)}"
                    @cancelled="isDatePickerClicked=false"
                    @change="onCalenderChange(selectedDateFilter,date-one,date-two)"
                    @apply="calenderClicked(index1, index2)" />
                </div>
              </div>
            </div>
          </div>
          <div class="cardlist" v-else-if="filter.type === 'SingleDate'">
            <div class="cardlist-title">
              <label>{{filter.tlabel? $t(filter.tlabel) : filter.category}}</label>
            </div>
            <div class="datepickerrange">
              <DatePicker type="date" prefix="false"
                :placeholder="$t('INDENT_PICK_DATE')" v-model="filter.selected"
                :clearable="false"
                @change="updateSingleDate(index1, index2, filter.selected, filter.type)" />
                <div class="datepicker-cancel">
                  <svgicon v-if="filter.optional && formattedDate(filter.selected)" name="cancelblack" class="icon-clear" @click="$emit('clearSingleDate',index1,index2)" width="9" height="9" :original="true" />
                  <svgicon v-else name="fill_arrow" width="9" height="9" :original="true" />
                </div>
              </div>
          </div>
          <div class="cardlist" v-else-if="filter.type === 'Toggle'">
            <div class="cardlist-title">
              <label>{{filter.tlabel? $t(filter.tlabel) : filter.category}}</label>
            </div>
            <SwitchBtn
                v-model="filter.selected"
                label="right"
                size="small"
                active-text="YES"
                inactive-text="NO"
                class="default-switch ml-10">
            </SwitchBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="sliderfilter-cardbtn">
      <button class="btn section_obtn" v-on:click="reset()">{{ $t('RESET_ALL') }}</button>
      <Button v-if="!disableApply" class="btn section_pbtn" @click="search" :disabled="isDisabled">{{ $t('APPLY') }}</Button>
    </div>
  </div>
</template>

<script>
import FilterCategory from '@common/components/FilterCategory';
import FilterGroupCategory from '@common/components/FilterGroupCategory';
import FilterMultipleDropdown from '@common/components/FilterMultipleDropdown';
import MultiSelectGroup from '@common/components/MultiSelectGroup';
import { formatDisplayDate, formatDisplaySingleDate } from '@/lib/Date';

export default {
  props: [
    'selectedFilters',
    'filters',
    'disableApply',
    'selectedDateFilter',
    'swimLane',
    'isDisabled'
  ],
  components: {
    FilterCategory,
    FilterMultipleDropdown,
    FilterGroupCategory,
    MultiSelectGroup
  },
  data() {
    return {
      minDate: null,
      maxDate: null,
      isDatePickerClicked: false,
      disableDeliver: false,
    };
  },
  computed: {
    keys() {
      return Object.keys(this.selectedFilters);
    },
  },
  methods: {
    calenderClicked(index1, index2) {
      this.isDatePickerClicked=false;
      if(this.selectedDateFilter === this.$t('INDENT_VEHICLE').toLowerCase() ){
         this.disableDeliver = true ;
         this.$emit('disableDeliver', true, index1, index2);
      }
    },
    closePicker() {
      this.isDatePickerClicked=false;
    },
    checkPermission(filter) {
      return filter.hasOwnProperty('hasPermission')?filter.hasPermission: true;
    },
    formattedDate(startDate,endDate = null) {
      if(endDate) {
        return formatDisplayDate(startDate,endDate);
      }
      return formatDisplaySingleDate(startDate);
    },
    changeRadio(index1, index2) {
      this.$emit('updateRadio', index1, index2);
    },
    updateOption(index1, index2, data, category) {
      this.$emit('updateOption', index1, index2, data, category);
    },
    updateDate(val, type, index1, index2) {
      this.$emit('updateOption', index1, index2, val, type, this.selectedDateFilter);
    },
    search() {
      const source = this.swimLane ? this.selectedFilters : this;
      const params = this.keys.reduce((acc, key) => {
        acc[key] = source[key];
        return acc;
      }, {});

      this.$emit('search', params);
    },
    clearDate() {
      this.startDate = '';
      this.endDate = '';
    },
    updateSingleDate(index1, index2, selectedValue, dataType) {
      this.$emit('updateOption', index1, index2, selectedValue, dataType);
    },
    getDateRange(type,dateVal, index1, index2){
      if(type === this.$t('INDENT_VEHICLE').toLowerCase())
      { 
        var date = null;
        date= new Date(dateVal)
      this.selectedFilters[index1][index2].endDate = null;
      this.minDate =  date.setDate(date.getDate() - 11);
      this.maxDate =  date.setDate(date.getDate() + 20);
      }
      else {
        this.minDate =  null;
        this.maxDate =  null;
      }
    },
    reset(){
      this.selectedDateFilter = 'creation';
      this.$emit('reset');

    if (Array.isArray(this.$refs.multiSelectGroupRef)) {
      this.$refs.multiSelectGroupRef.forEach(ref => {
      if (ref && typeof ref.reset === 'function') {
        ref.reset();
        }
      });
    }
    }
  },
};
</script>
